export interface UnitEditSection {
  label: string;
  // The section's route under the edit unit page.
  path: string;
}

// The legacy unit form (admin/units/_form_body), regrouped: the lesson list that sat above and
// below it is the Lessons section, the video manager the Unit Video section.
const unitEditSections: UnitEditSection[] = [
  { label: 'Unit Information', path: '' },
  { label: 'Lessons', path: 'lessons' },
  { label: 'Unit Image', path: 'image' },
  { label: 'Unit Video', path: 'video' },
  { label: 'Resources', path: 'resources' },
  { label: 'Unit Projects Description', path: 'description' },
];

export default unitEditSections;
